const BASE_URL: string = '/i';

/**
 * 
 */
export const INIT_PATH = {

  INIT: BASE_URL,
}